import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios_instance from '../api/axios_instance';
import { fetchSettings } from '../redux/settingsSlice';
import { Loader2, Save, Truck } from 'lucide-react';

const Settings = () => {
  const dispatch = useDispatch();
  const [deliveryFee, setDeliveryFee] = useState('');
  const [loading, setLoading]         = useState(true);
  const [saving, setSaving]           = useState(false);
  const [saved, setSaved]             = useState(false);

  useEffect(() => {
    axios_instance.get('/api/settings').then(res => {
      setDeliveryFee(res.data.deliveryFee);
    }).finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    const fee = parseFloat(deliveryFee);
    if (isNaN(fee) || fee < 0) return;
    setSaving(true);
    try {
      await axios_instance.put('/api/settings', { deliveryFee: fee });
      dispatch(fetchSettings());
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (err) {
      alert('فشل الحفظ');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return (
    <div className="flex justify-center items-center min-h-[40vh]">
      <Loader2 className="animate-spin text-emerald-600" size={40} />
    </div>
  );

  return (
    <div className="max-w-xl space-y-8" dir="rtl">
      <div>
        <h2 className="text-4xl font-black text-gray-900">الإعدادات</h2>
        <p className="text-gray-500 font-bold mt-1">إعدادات عامة للمتجر</p>
      </div>

      <div className="bg-white border border-gray-200 rounded-3xl p-8 space-y-6">
        <div className="flex items-center gap-3 pb-4 border-b border-gray-100">
          <div className="p-3 bg-emerald-50 rounded-2xl">
            <Truck size={20} className="text-emerald-600" />
          </div>
          <div>
            <h3 className="font-black text-gray-900">مصاريف التوصيل</h3>
            <p className="text-xs text-gray-400 font-bold">تُضاف تلقائياً على كل طلبية</p>
          </div>
        </div>

        <div>
          <label className="block text-xs font-black text-gray-500 mb-2">سعر التوصيل (د.ت)</label>
          <div className="flex items-center gap-3">
            <input
              type="number"
              min="0"
              step="0.001"
              value={deliveryFee}
              onChange={(e) => setDeliveryFee(e.target.value)}
              className="flex-1 px-4 py-3 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-50 outline-none font-black text-gray-900 text-lg transition-all"
            />
            <span className="font-black text-gray-400">د.ت</span>
          </div>
        </div>

        <button
          onClick={handleSave}
          disabled={saving}
          className="w-full py-4 bg-emerald-600 text-white rounded-2xl font-black text-base hover:bg-emerald-700 transition-all flex items-center justify-center gap-2 disabled:opacity-50"
        >
          {saving ? <Loader2 className="animate-spin w-5 h-5" /> : <Save size={18} />}
          {saved ? '✓ تم الحفظ' : 'حفظ الإعدادات'}
        </button>
      </div>
    </div>
  );
};

export default Settings;
